// extracted by mini-css-extract-plugin
export default {"iconRequest":"menuNavigation_iconRequest__YLwE0"};